var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinearIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.403 37.4l26.198 26.197C13.223 61.336 2.664 50.777.403 37.399v.001zM0 30.287L33.713 64a31.992 31.992 0 005.852-.858L.858 24.435c-.46 1.89-.75 3.847-.858 5.852zm2.536-10.883l42.06 42.06a31.944 31.944 0 004.4-2.31l-44.15-44.15a31.933 31.933 0 00-2.31 4.4zm5.159-8.259C13.568 4.32 22.268 0 31.977 0 49.663 0 64 14.337 64 32.023c0 9.71-4.32 18.41-11.145 24.282l-45.16-45.16z",
    fill: "#5E6AD2"
  })));
}
export default SvgLinearIcon;